import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  ApiRequestError,
  Button,
  Header,
} from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { OAuth2ClientCard } from "@sso/oauth2-clients/components";
import { useOAuth2Client } from "@sso/oauth2-clients/hooks";

export default function ViewOAuth2ClientPage() {
  let { id }: { id: string } = useParams();
  const { status, data, error, isFetching } = useOAuth2Client(Number(id));
  const history = useHistory();

  return (
    <>
      <Header
        title={`Client de OAuth2 #${id}`}
        backTo="/sso/oauth2-clients"
        buttons={
          <Restricted to="edit.users">
            <Button
              color="primary"
              onClick={() => history.push(`/sso/oauth2-clients/${id}/edit`)}
            >
              Editar
            </Button>
          </Restricted>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/sso/oauth2-clients", label: "Clientes de OAuth2" },
            { label: `#${id}` },
          ]}
        />
      </Header>

      {status === "loading" ? (
        <ApiLoadingSpinner />
      ) : status === "error" ? (
        <ApiRequestError error={error} />
      ) : (
        <>
          {data ? (
            <OAuth2ClientCard client={data} />
          ) : (
            <p>Cliente de OAuth2 não encontrado.</p>
          )}
          {isFetching ? <ApiUpdatingSpinner /> : null}
        </>
      )}
    </>
  );
}
